/*
  MilAura : socle commun d'occasion (PDP cadeau, PDP calendrier, landing).
  Dates limites incluses, à l'heure de Paris, formulées « jusqu'au ».
  Le jour courant est calculé ici, car les pages sont servies depuis le cache.
  Spécification : docs/superpowers/specs/2026-10-17-pdp-cadeau-design.md, § 6.
*/
(function (root) {
  'use strict';

  var MODES = ['relais', 'domicile', 'express'];
  var LIBELLES = { relais: 'en point relais', domicile: 'à domicile', express: 'en express' };
  var TITRES = { relais: 'Point relais', domicile: 'À domicile', express: 'Express' };
  var MOIS = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long', timeZone: 'UTC' });
  var MOIS_COURT = new Intl.DateTimeFormat('fr-FR', { month: 'short', timeZone: 'UTC' });
  var SEMAINE = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', timeZone: 'UTC' });
  var JOUR = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
  var PARIS = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' });

  function texte(valeur) {
    return valeur == null ? '' : String(valeur).trim();
  }

  function utc(iso) {
    var p = iso.split('-');
    return Date.UTC(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
  }

  function ecart(de, a) {
    return Math.round((utc(a) - utc(de)) / 86400000);
  }

  function premier(chaine, iso) {
    return Number(iso.split('-')[2]) === 1 ? chaine.replace(/(^|\s)1 /, '$11er ') : chaine;
  }

  function formatJour(iso) {
    return premier(MOIS.format(new Date(utc(iso))), iso);
  }

  function formatJourLong(iso) {
    var chaine = premier(JOUR.format(new Date(utc(iso))), iso);
    return chaine.charAt(0).toUpperCase() + chaine.slice(1);
  }

  function jourParis(date) {
    var parties = {};
    PARIS.formatToParts(date).forEach(function (partie) {
      parties[partie.type] = partie.value;
    });
    return parties.year + '-' + parties.month + '-' + parties.day;
  }

  function limitesEffectives(occasion) {
    var unique = texte(occasion.limite_unique);
    if (unique) return [{ date: unique, modes: [] }];
    var parDate = {};
    var ordre = [];
    MODES.forEach(function (mode) {
      var date = texte(occasion['limite_' + mode]);
      if (!date) return;
      if (!parDate[date]) {
        parDate[date] = { date: date, modes: [] };
        ordre.push(parDate[date]);
      }
      parDate[date].modes.push(mode);
    });
    return ordre.sort(function (a, b) {
      return a.date < b.date ? -1 : a.date > b.date ? 1 : 0;
    });
  }

  function libelleModes(limite, plusieurs) {
    if (!plusieurs || !limite.modes.length) return '';
    return ' ' + limite.modes.map(function (mode) { return LIBELLES[mode]; }).join(' et ');
  }

  function formatDecompte(jours) {
    if (jours <= 0) return 'Dernier jour.';
    if (jours === 1) return 'Encore 1 jour.';
    return 'Encore ' + jours + ' jours.';
  }

  function premiereDateUtile(occasion, aujourdhui) {
    var limites = limitesEffectives(occasion).filter(function (l) { return l.date >= aujourdhui; });
    return limites.length ? limites[0].date : texte(occasion.date_evenement);
  }

  function phrase(occasion, aujourdhui, options, plusieursOccasions) {
    var evenement = texte(occasion.date_evenement);
    if (evenement && evenement < aujourdhui) return '';
    var limites = limitesEffectives(occasion);
    if (!limites.length) return '';
    var plusieurs = limites.length > 1;
    var dujour = limites.filter(function (l) { return l.date === aujourdhui; });
    var futures = limites.filter(function (l) { return l.date > aujourdhui; });

    if (!dujour.length && !futures.length) {
      if (options.apres === 'masquer') return '';
      return plusieursOccasions
        ? texte(occasion.nom_gamme) + ' : date limite passée.'
        : 'La date limite pour une livraison avant ' + texte(occasion.nom) + ' est passée.';
    }

    var morceaux = dujour.map(function (l) {
      return "aujourd'hui dernier jour" + libelleModes(l, plusieurs);
    }).concat(futures.map(function (l) {
      return "jusqu'au " + formatJour(l.date) + libelleModes(l, plusieurs);
    }));
    var coeur = morceaux.join(', ');
    var but = texte(occasion.but_ligne);
    var resultat;

    if (plusieursOccasions) {
      resultat = texte(occasion.nom_gamme) + ' : ' + coeur + '.';
    } else if (but) {
      resultat = futures.length ? 'Commandez ' + coeur + ' ' + but + '.' : "Aujourd'hui dernier jour pour commander " + but + '.';
    } else if (dujour.length) {
      resultat = 'Pour ' + texte(occasion.nom) + ' : ' + coeur + '.';
    } else {
      resultat = 'Pour ' + texte(occasion.nom) + ', commandez ' + coeur + '.';
    }

    if (options.decompte) {
      var prochaine = (dujour.length ? dujour[0] : futures[0]).date;
      resultat += ' ' + formatDecompte(ecart(aujourdhui, prochaine));
    }
    return resultat;
  }

  function ligne(occasions, aujourdhui, options) {
    var liste = (occasions || []).filter(Boolean);
    var reglages = options || {};
    var plusieurs = liste.length > 1;
    return liste
      .slice()
      .sort(function (a, b) {
        var da = premiereDateUtile(a, aujourdhui);
        var db = premiereDateUtile(b, aujourdhui);
        return da < db ? -1 : da > db ? 1 : 0;
      })
      .map(function (occasion) { return phrase(occasion, aujourdhui, reglages, plusieurs); })
      .filter(Boolean)
      .join(' ');
  }

  /* options.evenement : false pour une frise des seules dates limites (sans la feuille de l'événement). */
  function fil(occasions, aujourdhui, options) {
    var avecEvenement = !options || options.evenement !== false;
    var elements = [];
    var nomsAvecLimites = [];
    (occasions || []).filter(Boolean).forEach(function (occasion) {
      var evenement = texte(occasion.date_evenement);
      if (!evenement || evenement < aujourdhui) return;
      var limites = limitesEffectives(occasion);
      var plusieurs = limites.length > 1;
      if (limites.length) nomsAvecLimites.push(texte(occasion.nom));
      limites.forEach(function (l) {
        elements.push({
          date: l.date,
          type: 'limite',
          modes: plusieurs ? l.modes.slice() : [],
          passe: l.date < aujourdhui,
          reste: l.date >= aujourdhui ? ecart(aujourdhui, l.date) : null,
          nom: texte(occasion.nom),
          nomGamme: texte(occasion.nom_gamme),
          texteEvenement: ''
        });
      });
      if (!avecEvenement) return;
      elements.push({
        date: evenement,
        type: 'evenement',
        modes: [],
        passe: false,
        reste: null,
        nom: texte(occasion.nom),
        nomGamme: texte(occasion.nom_gamme),
        texteEvenement: texte(occasion.texte_evenement)
      });
    });
    if (!elements.length) return [];
    /* Un seul « aujourd'hui » : pas de repère du jour quand une limite ou l'événement tombe ce jour-là. */
    var elementDuJour = elements.some(function (e) { return e.date === aujourdhui; });
    if (!elementDuJour) {
      var limites = elements.filter(function (e) { return e.type === 'limite'; });
      var limitesPassees = limites.length > 0 && !limites.some(function (e) { return e.date >= aujourdhui; });
      elements.push({
        date: aujourdhui,
        type: 'aujourdhui',
        modes: [],
        passe: false,
        reste: null,
        limitesPassees: limitesPassees,
        nom: nomsAvecLimites.join(' et '),
        nomGamme: '',
        texteEvenement: ''
      });
    }
    var rang = { aujourdhui: 0, limite: 1, evenement: 2 };
    return elements.sort(function (a, b) {
      if (a.date !== b.date) return a.date < b.date ? -1 : 1;
      return rang[a.type] - rang[b.type];
    });
  }

  /* ---------- Frise en feuilles de calendrier (maquette validée le 2026-10-20) ---------- */

  function feuille(element) {
    var date = new Date(utc(element.date));
    var resultat = {
      mois: MOIS_COURT.format(date),
      jour: String(Number(element.date.split('-')[2])),
      semaine: SEMAINE.format(date),
      titre: '',
      detail: ''
    };
    if (element.type === 'aujourdhui') {
      /* La feuille du jour se suffit : « Aujourd'hui » et sa date (choix de Patrice du 2026-10-23). */
      resultat.titre = "Aujourd'hui";
    } else if (element.type === 'limite') {
      /* La date est sur la feuille : le libellé dit seulement que c'est la date limite de commande. */
      if (element.modes.length) {
        resultat.titre = element.modes.map(function (mode, rang) {
          var titre = TITRES[mode];
          return rang ? titre.charAt(0).toLowerCase() + titre.slice(1) : titre;
        }).join(' et ');
        resultat.detail = element.passe ? 'date passée' : element.reste === 0 ? 'dernier jour de commande' : 'date limite de commande';
      } else {
        resultat.titre = element.reste === 0 && !element.passe ? 'Dernier jour de commande' : 'Date limite de commande';
        resultat.detail = element.passe ? 'date passée' : '';
      }
    } else {
      /* « Le soir du réveillon, elle décroche l'écrin. » : avant la virgule en titre, après en détail. */
      var phraseEvenement = element.texteEvenement.replace(/\.$/, '');
      var coupure = phraseEvenement.indexOf(', ');
      resultat.titre = coupure > 0 ? phraseEvenement.slice(0, coupure) : element.nom;
      resultat.detail = coupure > 0 ? phraseEvenement.slice(coupure + 2) : phraseEvenement;
    }
    return resultat;
  }

  function nombreJours(jours) {
    return jours + (jours === 1 ? ' jour' : ' jours');
  }

  function note(occasions, aujourdhui) {
    var liste = (occasions || []).filter(Boolean);
    if (liste.length !== 1) return '';
    var occasion = liste[0];
    var evenement = texte(occasion.date_evenement);
    if (!evenement || evenement < aujourdhui) return '';
    var limites = limitesEffectives(occasion);
    if (!limites.length) return '';
    var nom = texte(occasion.nom);
    var utiles = limites.filter(function (l) { return l.date >= aujourdhui; });
    if (!utiles.length) return 'La date limite pour une livraison avant ' + nom + ' est passée.';
    var plusieurs = limites.length > 1;
    return utiles.map(function (l, rang) {
      var jours = ecart(aujourdhui, l.date);
      var modes = plusieurs && l.modes.length ? l.modes.map(function (m) { return LIBELLES[m]; }).join(' et ') : '';
      if (rang === 0) {
        return (jours === 0 ? "Dernier jour aujourd'hui" : 'Encore ' + nombreJours(jours)) +
          (modes ? ' pour une livraison ' + modes : ' pour commander avant ' + nom);
      }
      return (jours === 0 ? "dernier jour aujourd'hui" : nombreJours(jours)) + (modes ? ' ' + modes : '');
    }).join(', ') + '.';
  }

  function echapper(chaine) {
    return String(chaine).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var BRANCHE = '<svg class="milaura-occasion-fil__branche" viewBox="0 0 40 40" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round">' +
    '<path d="M6 34 C 16 26, 24 18, 34 6"/>' +
    '<path d="M12 29 l-6 -1 M12 29 l1 6 M17 25 l-7 -2 M17 25 l1 7 M22 20 l-7 -3 M22 20 l2 7 M27 15 l-6 -3 M27 15 l2 6 M31 10 l-4 -3 M31 10 l2 4"/>' +
    '<circle cx="9" cy="22" r="1.6" fill="currentColor" stroke="none"/></svg>';

  function htmlFil(elements, plusieurs) {
    return elements.map(function (e) {
      var classes = ['milaura-occasion-fil__item'];
      if (e.type === 'aujourdhui' || (e.type === 'limite' && e.reste === 0)) classes.push('is-aujourdhui');
      if (e.type === 'evenement') classes.push('is-evenement');
      if (e.passe) classes.push('is-passe');
      var f = feuille(e);
      var gamme = plusieurs && e.nomGamme ? '<p class="milaura-occasion-fil__gamme">' + echapper(e.nomGamme) + '</p>' : '';
      return '<li class="' + classes.join(' ') + '">' + gamme +
        '<span class="milaura-occasion-fil__feuille">' + (e.type === 'evenement' ? BRANCHE : '') +
        '<span class="milaura-occasion-fil__mois">' + echapper(f.mois) + '</span>' +
        '<span class="milaura-occasion-fil__jour">' + echapper(f.jour) + '</span>' +
        '<span class="milaura-occasion-fil__semaine">' + echapper(f.semaine) + '</span></span>' +
        '<p class="milaura-occasion-fil__libelle"><strong>' + echapper(f.titre) + '</strong>' +
        (f.detail ? '<span>' + echapper(f.detail) + '</span>' : '') + '</p>' +
        '</li>';
    }).join('');
  }

  var api = {
    jourParis: jourParis,
    limitesEffectives: limitesEffectives,
    ligne: ligne,
    fil: fil,
    feuille: feuille,
    note: note,
    htmlFil: htmlFil,
    formatJour: formatJour,
    formatJourLong: formatJourLong,
    formatDecompte: formatDecompte,
    libelleMode: function (mode) { return LIBELLES[mode] || ''; }
  };

  root.MilauraOccasion = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;

  /* ---------- Rendu dans la page ---------- */
  if (typeof document === 'undefined') return;

  function rendreFil(conteneur, occasions, aujourdhui) {
    var elements = fil(occasions, aujourdhui, { evenement: conteneur.getAttribute('data-evenement') !== 'false' });
    var section = conteneur.closest('[data-milaura-occasion-section]');
    if (!elements.length) {
      (section || conteneur).hidden = true;
      return;
    }
    conteneur.innerHTML = htmlFil(elements, occasions.length > 1);
    var noteElement = section && section.querySelector('[data-occasion-note]');
    if (noteElement) {
      var phraseNote = note(occasions, aujourdhui);
      noteElement.textContent = phraseNote;
      noteElement.hidden = !phraseNote;
    }
  }

  function rendre(element) {
    if (element.getAttribute('data-occasion-pret') === 'true') return;
    element.setAttribute('data-occasion-pret', 'true');
    var occasions;
    try {
      occasions = JSON.parse(element.getAttribute('data-milaura-occasion') || '[]');
    } catch (erreur) {
      return;
    }
    if (!Array.isArray(occasions)) occasions = [occasions];
    var aujourdhui = jourParis(new Date());
    if (element.getAttribute('data-mode') === 'fil') {
      rendreFil(element, occasions, aujourdhui);
      return;
    }
    var resultat = ligne(occasions, aujourdhui, {
      decompte: element.getAttribute('data-decompte') === 'true',
      apres: element.getAttribute('data-apres') || 'message'
    });
    element.textContent = resultat;
    element.hidden = !resultat;
  }

  function toutRendre(portee) {
    Array.prototype.forEach.call((portee || document).querySelectorAll('[data-milaura-occasion]'), rendre);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { toutRendre(document); });
  } else {
    toutRendre(document);
  }
  document.addEventListener('shopify:section:load', function (evenement) { toutRendre(evenement.target); });
})(typeof window !== 'undefined' ? window : this);
